var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00A6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9371 5.90625L14.0496 6.09244C14.6105 7.03447 14.9065 8.11059 14.9062 9.207C14.8961 12.5077 12.2541 15.1875 9 15.1875H8.98987C5.73581 15.1875 3.08362 12.4869 3.09375 9.18619C3.09375 8.07919 3.39975 7.00312 3.96056 6.07162L4.06294 5.89613L4.6035 6.44456C4.49635 6.60119 4.41065 6.77145 4.34869 6.95081C4.14258 7.52194 4.1706 8.15138 4.42665 8.70193C4.68269 9.25248 5.146 9.67949 5.71556 9.88988C6.0504 10.0091 6.40862 10.0478 6.76121 10.0029C7.1138 9.95793 7.45085 9.83057 7.74506 9.63112L9 10.9142L10.4383 9.45506C10.5711 9.54844 10.7241 9.621 10.8872 9.68288C12.0403 10.0969 13.3048 9.486 13.7126 8.32725C13.9573 7.64437 13.8454 6.93056 13.4882 6.36131L13.9371 5.90625ZM5.26669 7.11675L6.95981 8.82394C6.75562 8.98988 6.50081 9.08269 6.22519 9.08269C5.56256 9.08269 5.02144 8.53425 5.02144 7.86206C5.02144 7.5825 5.11369 7.32375 5.26669 7.11675ZM11.1729 8.72044L12.8458 7.02394C12.9786 7.22081 13.0494 7.45819 13.0494 7.70681C13.0494 8.379 12.5094 8.92744 11.8457 8.92744C11.5909 8.92744 11.3664 8.85488 11.1729 8.72044ZM9.02025 10.0035L4.1445 5.03663L4.338 4.83019C5.54175 3.53644 7.18425 2.8125 8.94937 2.8125H8.9595C10.7449 2.8125 12.4582 3.58875 13.6519 4.93313L13.8358 5.14069L9.02081 10.0035H9.02025ZM4.93987 5.03663L9.02025 9.18619L13.05 5.11988C11.9689 4.023 10.5002 3.39188 8.97019 3.39188H8.9595C7.43962 3.39188 6.02212 3.97125 4.94044 5.03719L4.93987 5.03663Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGno);
export default __webpack_public_path__ + "static/media/gno.b94bd30ad5954502ffcef2775a7f8bad.svg";
export { ForwardRef as ReactComponent };